import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { RingLoader } from "react-spinners";
import Multiselect from "react-widgets/Multiselect";
import Switch from "react-switch";
import "react-widgets/styles.css";

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const CanvasContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const isMobile = window.innerWidth <= 768;

let listLangTable = [
    { value: "afr", name: "Afrikaans", code: "af" },
    { value: "amh", name: "Amharic", code: "am" },
    { value: "ara", name: "Arabic", code: "ar" },
    { value: "asm", name: "Assamese", code: "as" },
    { value: "aze", name: "Azerbaijani", code: "az" },
    { value: "aze_cyrl", name: "Azerbaijani - Cyrilic", code: null },
    { value: "bel", name: "Belarusian", code: "be" },
    { value: "ben", name: "Bengali", code: "bn" },
    { value: "bod", name: "Tibetan", code: "bo" },
    { value: "bos", name: "Bosnian", code: "bs" },
    { value: "bre", name: "Breton", code: "br" },
    { value: "bul", name: "Bulgarian", code: "bg" },
    { value: "cat", name: "Catalan; Valencian", code: "ca" },
    { value: "ceb", name: "Cebuano", code: null },
    { value: "ces", name: "Czech", code: "cs" },
    { value: "chi_sim", name: "Chinese simplified", code: "zh" },
    { value: "chi_tra", name: "Chinese traditional", code: "zh" },
    { value: "chr", name: "Cherokee", code: null },
    { value: "cym", name: "Welsh", code: "cy" },
    { value: "dan", name: "Danish", code: "da" },
    { value: "deu", name: "German", code: "de" },
    { value: "dzo", name: "Dzongkha", code: "dz" },
    { value: "ell", name: "Greek, Modern, 1453-", code: "el" },
    { value: "eng", name: "English", code: "en" },
    { value: "enm", name: "English, Middle, 1100-1500", code: null },
    { value: "epo", name: "Esperanto", code: "eo" },
    { value: "equ", name: "Math / equation detection module", code: null },
    { value: "est", name: "Estonian", code: "et" },
    { value: "eus", name: "Basque", code: "eu" },
    { value: "fas", name: "Persian", code: "fa" },
    { value: "fin", name: "Finnish", code: "fi" },
    { value: "fra", name: "French", code: "fr" },
    { value: "frk", name: "Frankish", code: null },
    { value: "frm", name: "French, Middle, ca.1400-1600", code: null },
    { value: "gle", name: "Irish", code: "ga" },
    { value: "glg", name: "Galician", code: "gl" },
    { value: "grc", name: "Greek, Ancient, to 1453", code: null },
    { value: "guj", name: "Gujarati", code: "gu" },
    { value: "hat", name: "Haitian; Haitian Creole", code: "ht" },
    { value: "heb", name: "Hebrew", code: "he" },
    { value: "hin", name: "Hindi", code: "hi" },
    { value: "hrv", name: "Croatian", code: "hr" },
    { value: "hun", name: "Hungarian", code: "hu" },
    { value: "iku", name: "Inuktitut", code: "iu" },
    { value: "ind", name: "Indonesian", code: "id" },
    { value: "isl", name: "Icelandic", code: "is" },
    { value: "ita", name: "Italian", code: "it" },
    { value: "ita_old", name: "Italian - Old", code: null },
    { value: "jav", name: "Javanese", code: "jv" },
    { value: "jpn", name: "Japanese", code: "ja" },
    { value: "kan", name: "Kannada", code: "kn" },
    { value: "kat", name: "Georgian", code: "ka" },
    { value: "kat_old", name: "Georgian - Old", code: null },
    { value: "kaz", name: "Kazakh", code: "kk" },
    { value: "khm", name: "Central Khmer", code: "km" },
    { value: "kir", name: "Kirghiz; Kyrgyz", code: "ky" },
    { value: "kmr", name: "Kurdish Kurmanji", code: null },
    { value: "kor", name: "Korean", code: "ko" },
    { value: "kor_vert", name: "Korean vertical", code: null },
    { value: "kur", name: "Kurdish", code: "ku" },
    { value: "lao", name: "Lao", code: "lo" },
    { value: "lat", name: "Latin", code: "la" },
    { value: "lav", name: "Latvian", code: "lv" },
    { value: "lit", name: "Lithuanian", code: "lt" },
    { value: "ltz", name: "Luxembourgish", code: "lb" },
    { value: "mal", name: "Malayalam", code: "ml" },
    { value: "mar", name: "Marathi", code: "mr" },
    { value: "mkd", name: "Macedonian", code: "mk" },
    { value: "mlt", name: "Maltese", code: "mt" },
    { value: "mon", name: "Mongolian", code: "mn" },
    { value: "mri", name: "Maori", code: "mi" },
    { value: "msa", name: "Malay", code: "ms" },
    { value: "mya", name: "Burmese", code: "my" },
    { value: "nep", name: "Nepali", code: "ne" },
    { value: "nld", name: "Dutch; Flemish", code: "nl" },
    { value: "nor", name: "Norwegian", code: "no" },
    { value: "oci", name: "Occitan post 1500", code: "oc" },
    { value: "ori", name: "Oriya", code: "or" },
    {
        value: "osd",
        name: "Orientation and script detection module",
        code: null,
    },
    { value: "pan", name: "Panjabi; Punjabi", code: "pa" },
    { value: "pol", name: "Polish", code: "pl" },
    { value: "por", name: "Portuguese", code: "pt" },
    { value: "pus", name: "Pushto; Pashto", code: "ps" },
    { value: "que", name: "Quechua", code: "qu" },
    { value: "ron", name: "Romanian; Moldavian; Moldovan", code: "ro" },
    { value: "rus", name: "Russian", code: "ru" },
    { value: "san", name: "Sanskrit", code: "sa" },
    { value: "sin", name: "Sinhala; Sinhalese", code: "si" },
    { value: "slk", name: "Slovak", code: "sk" },
    { value: "slv", name: "Slovenian", code: "sl" },
    { value: "snd", name: "Sindhi", code: "sd" },
    { value: "spa", name: "Spanish; Castilian", code: "es" },
    { value: "spa_old", name: "Spanish; Castilian - Old", code: null },
    { value: "sqi", name: "Albanian", code: "sq" },
    { value: "srp", name: "Serbian", code: "sr" },
    { value: "srp_latn", name: "Serbian - Latin", code: null },
    { value: "sun", name: "Sundanese", code: "su" },
    { value: "swa", name: "Swahili", code: "sw" },
    { value: "swe", name: "Swedish", code: "sv" },
    { value: "syr", name: "Syriac", code: null },
    { value: "tam", name: "Tamil", code: "ta" },
    { value: "tat", name: "Tatar", code: "tt" },
    { value: "tel", name: "Telugu", code: "te" },
    { value: "tgk", name: "Tajik", code: "tg" },
    { value: "tgl", name: "Tagalog", code: "tl" },
    { value: "tha", name: "Thai", code: "th" },
    { value: "tir", name: "Tigrinya", code: "ti" },
    { value: "ton", name: "Tonga", code: null },
    { value: "tur", name: "Turkish", code: "tr" },
    { value: "uig", name: "Uighur; Uyghur", code: "ug" },
    { value: "ukr", name: "Ukrainian", code: "uk" },
    { value: "urd", name: "Urdu", code: "ur" },
    { value: "uzb", name: "Uzbek", code: "uz" },
    { value: "uzb_cyrl", name: "Uzbek - Cyrilic", code: null },
    { value: "vie", name: "Vietnamese", code: "vi" },
    { value: "yid", name: "Yiddish", code: "yi" },
    { value: "yor", name: "Yoruba", code: "yo" },
];

const RecognizeTextViewer = (props) => {
    const {
        titleDownload,
        titleDownloadAll,
        titleCopy,
        titleCopied,
        titleDelete,
        titleReady,
        titleCancel,
        titleCurrentFile,
        titleRecognize,
        titleRecognizeTextAnotherImage,
        titleChooseIntendedLanguage,
        titleApplyFilter,
        tip1,
        localeCode,
    } = props.attributes;

    const [showImage, setShowImage] = useState(true);
    const [fileId, setFileId] = useState(props.fileId);
    const [fileName, setFileName] = useState(props.fileName);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [open, setOpen] = useState(false);
    const [lang, setLang] = useState([]);
    const [text, setText] = useState("");
    const [switchValue1, setSwitchValue1] = useState(false);
    const canvasRef = useRef(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth * 0.9,
        height: window.innerHeight,
    });

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleLanguageChange = (value) => {
        setLang(value);
        setOpen(false);
    };

    const handleChangeSwitch1 = () => {
        setSwitchValue1(!switchValue1);
        console.log(switchValue1);
    };

    const handleResize = () => {
        setWindowSize({
            width: window.innerWidth * 0.9,
            height: window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (localeCode) {
            const foundLang = listLangTable.find(
                (lang) => lang.code === localeCode
            );
            if (foundLang) {
                setLang([foundLang]);
            }
        }
    }, [localeCode]);

    const drawImageProportional = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        const image = new Image();
        image.src = props.imageUrl;

        const drawImage = () => {
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const imageWidth = image.width;
            const imageHeight = image.height;

            const maxImageSize = Math.min(canvasWidth, canvasHeight);
            const scaleFactor =
                maxImageSize / Math.max(imageWidth, imageHeight);

            const scaledWidth = imageWidth * scaleFactor;
            const scaledHeight = imageHeight * scaleFactor;

            const x = (canvasWidth - scaledWidth) / 2;
            const y = (canvasHeight - scaledHeight) / 2;

            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            ctx.drawImage(image, x, y, scaledWidth, scaledHeight);
        };

        if (image.complete) {
            drawImage();
        } else {
            image.onload = drawImage;
        }
    };

    useEffect(() => {
        drawImageProportional();
        window.addEventListener("resize", drawImageProportional);
        return () => {
            window.removeEventListener("resize", drawImageProportional);
        };
    }, [props.imageUrl, windowSize]);

    useEffect(() => {
        if (showImage) {
            drawImageProportional();
        }
    }, [props.imageUrl, showImage]);

    const handleRecognizeText = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowImage(false);

        const requestBody = {
            fileid: props.fileId,
            lang: lang,
            switchValue1: switchValue1,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/recognizeText?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setText(responseData.text);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowImage(true);
        props.setShowUploader(true);
    };

    const handleCancel = () => {
        setShowImage(false);
    };

    const reloadPage = () => {
        setShowImage(true);
        location.reload();
    };

    const [isCopied, setIsCopied] = useState(false);

    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        setIsCopied(true);

        setTimeout(() => {
            setIsCopied(false);
            setIsDownloading(true);
        }, 5000);
    };

    return (
        <Container>
            {showImage && (
                <div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <CanvasContainer>
                            <canvas
                                width={windowSize.width * 0.5}
                                height={windowSize.height * 0.5}
                                ref={canvasRef}
                            />
                        </CanvasContainer>
                        <div
                            style={{
                                textAlign: "center",
                                paddingTop: "20px",
                                width: "90%",
                            }}
                            className="form-group"
                        >
                            <span
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    padding: "20px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "1.0em",
                                    borderRadius: "4px",
                                    marginBottom: "20px",
                                }}
                            >
                                <span>{titleChooseIntendedLanguage}</span>
                                <div style={{ width: "90%" }}>
                                    <Multiselect
                                        onToggle={handleToggle}
                                        open={open}
                                        name="chooseIntendedLanguage"
                                        data={listLangTable}
                                        valueField="value"
                                        textField="name"
                                        onChange={handleLanguageChange}
                                        value={lang}
                                    />
                                </div>
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "1em",
                            }}
                        >
                            <Switch
                                onChange={handleChangeSwitch1}
                                checked={switchValue1}
                            />
                            <span
                                style={{
                                    marginLeft: "10px",
                                    padding: "10px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                }}
                            >
                                {tip1}
                            </span>
                        </div>
                        <div
                            className="px-4 py-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {lang.length > 0 && (
                                <ButtonContainer>
                                    <StyledButton onClick={handleRecognizeText}>
                                        {titleRecognize}
                                    </StyledButton>
                                </ButtonContainer>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleRecognizeTextAnotherImage}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <>
                    <div
                        className="px-4 py-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "500px",
                            overflow: "auto",
                            whiteSpace: "pre-line",
                        }}
                    >
                        {text}
                    </div>

                    <div
                        className="px-4 py-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <button
                            className="bg-blue-500 text-white px-3 py-2 rounded focus:outline-none"
                            onClick={() => handleCopyToClipboard(text)}
                        >
                            {isCopied ? titleCopied : titleCopy}
                        </button>
                    </div>
                    <div
                        className="px-4 py-2"
                        style={{ display: "flex", justifyContent: "center" }}
                    >
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleRecognizeTextAnotherImage}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleRecognizeTextAnotherImage}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default RecognizeTextViewer;
